import React from 'react';
import { Link } from 'react-router-dom';

export default function AgencyLandingPage() {
  return (
    <div style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#1a1a1a', minHeight: '100vh' }}>

      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px 60px', borderBottom: '1px solid #e0e0e0' }}>
        <Link to="/" style={{ fontSize: 13, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', textDecoration: 'none', color: '#1a1a1a' }}>
          Clarity<span style={{ fontWeight: 300, opacity: 0.5 }}> Reporting</span>
        </Link>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <Link to="/login" style={{ fontSize: 13, color: '#888', textDecoration: 'none' }}>Sign In</Link>
          <Link to="/register" style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none', color: '#fff', background: '#1a1a1a', padding: '10px 24px' }}>Get Started</Link>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '80px 40px 60px', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#1a1a1a', color: '#FFE066', fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', padding: '6px 16px', marginBottom: 32 }}>
          For SEO Agencies
        </div>
        <h1 style={{ fontSize: 48, fontWeight: 700, lineHeight: 1.1, letterSpacing: -1, margin: '0 0 24px' }}>
          Independent data your clients can trust.
        </h1>
        <p style={{ fontSize: 18, color: '#555', lineHeight: 1.7, maxWidth: 600, margin: '0 auto 48px' }}>
          Give your clients a third-party verified report alongside your own. Build trust, reduce churn, and close new business with a one-click prospect analysis.
        </p>
        <Link to="/register" style={{ display: 'inline-block', padding: '16px 48px', background: '#1a1a1a', color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none' }}>
          Start Free Trial
        </Link>
      </div>

      {/* Two modes */}
      <div style={{ background: '#fafafa', borderTop: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', padding: '80px 40px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', textAlign: 'center', marginBottom: 48 }}>Two Modes Built for Agencies</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <div style={{ padding: '40px', border: '2px solid #1a1a1a', background: '#fff' }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#1a7a1a', marginBottom: 16 }}>Client Mode</div>
              <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>Ongoing weekly reporting</div>
              <div style={{ fontSize: 14, color: '#555', lineHeight: 1.8 }}>
                For your active clients. Weekly keyword rankings, competitor analysis, and monthly SEO health audits delivered automatically. Your clients get independent verification of the work you are doing.
              </div>
            </div>
            <div style={{ padding: '40px', border: '2px solid #CC0000', background: '#fff' }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#CC0000', marginBottom: 16 }}>Prospect Mode</div>
              <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>One-click sales tool</div>
              <div style={{ fontSize: 14, color: '#555', lineHeight: 1.8 }}>
                For prospective clients. Run a one-time analysis that generates a full SEO Action Plan with rankings, health score, and growth opportunities. Walk into any sales meeting with real data about their business.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '80px 40px' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', textAlign: 'center', marginBottom: 48 }}>Everything You Need</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}>
          {[
            { title: 'White-label reports', desc: 'Reports carry your agency branding, not ours. Your clients see your logo.' },
            { title: 'Unlimited clients', desc: 'Agency Pro plan supports unlimited client websites with no per-site fees.' },
            { title: 'Prospect action plans', desc: 'Generate a full SEO Action Plan for any prospect in minutes. No manual work.' },
            { title: 'Independent data', desc: 'Third-party verified rankings build trust. No conflict of interest.' },
            { title: 'Convert prospects', desc: 'One click converts a prospect to a client and starts weekly reporting automatically.' },
            { title: 'GSC integration', desc: 'Connect each client Google Search Console for the most accurate keyword data.' },
          ].map(f => (
            <div key={f.title}>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>{f.title}</div>
              <div style={{ fontSize: 13, color: '#666', lineHeight: 1.7 }}>{f.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Pricing */}
      <div style={{ background: '#fafafa', borderTop: '1px solid #e0e0e0', padding: '80px 40px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', textAlign: 'center', marginBottom: 48 }}>Agency Pricing</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            {[
              { name: 'Agency', price: '$99', desc: 'per month', features: ['Up to 20 client websites', 'Prospect analysis mode', 'White-label reports', 'Weekly reports for all clients', 'Monthly SEO health audits', 'Priority support'] },
              { name: 'Agency Pro', price: '$199', desc: 'per month', features: ['Unlimited client websites', 'Everything in Agency', 'Configurable keyword limits', 'Bulk prospect analysis', 'Dedicated account manager', 'Custom report scheduling'] },
            ].map(plan => (
              <div key={plan.name} style={{ background: '#fff', border: '1px solid #e0e0e0', padding: '40px' }}>
                <div style={{ fontSize: 14, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 }}>{plan.name}</div>
                <div style={{ fontSize: 42, fontWeight: 700, fontFamily: 'monospace', marginBottom: 4 }}>{plan.price}</div>
                <div style={{ fontSize: 13, color: '#888', marginBottom: 28 }}>{plan.desc}</div>
                {plan.features.map(f => (
                  <div key={f} style={{ display: 'flex', gap: 10, padding: '7px 0', borderBottom: '1px solid #f5f5f5', fontSize: 13 }}>
                    <span style={{ color: '#1a7a1a', fontWeight: 700, flexShrink: 0 }}>&#10003;</span> {f}
                  </div>
                ))}
                <Link to="/register" style={{ display: 'block', marginTop: 28, padding: '14px', background: '#1a1a1a', color: '#fff', fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none', textAlign: 'center' }}>
                  Get Started
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #e0e0e0', padding: '32px 60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <Link to="/" style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', opacity: 0.4, textDecoration: 'none', color: '#1a1a1a' }}>Clarity Reporting</Link>
        <div style={{ display: 'flex', gap: 24 }}>
          <Link to="/" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>For Website Owners</Link>
          <Link to="/privacy" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/terms" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>Terms of Service</Link>
        </div>
      </footer>

    </div>
  );
}
